export const projects = [
  {
    id: 1,
    title: '오늘뭐해 (ToDayApp)',
    description: '위치 기반 관광지 추천과 실시간 채팅을 하나로 묶은 안드로이드 앱입니다. 사용자의 GPS 좌표로 지역을 판별해 관광지를 추천하고, 같은 장소를 선택한 사람들이 좌표 기반 고유 채팅방에서 자연스럽게 만나 소통할 수 있게 만들었습니다. 이메일 인증 전까지는 임시 계정으로만 취급하는 Firebase Auth 인증 흐름을 직접 설계했고, 비활성 채팅방과 미인증 계정은 Cloud Functions가 자동으로 정리하도록 해 별도 관리 없이도 안정적으로 운영되도록 했습니다.',
    descKey: 'todayapp',
    category: 'mobile',
    tags: ['Java', 'Android', 'Firebase', 'Firestore'],
    github: 'https://github.com/ohdongE/ToDayApplication',
    demo: '',
    screenshots: [
      { src: '/assets/screenshots/todayapp/02-home.jpg', caption: 'todayappHome' },
      { src: '/assets/screenshots/todayapp/03-home-category-culture.jpg', caption: 'todayappCategory' },
      { src: '/assets/screenshots/todayapp/04-home-current-location.jpg', caption: 'todayappLocation' },
      { src: '/assets/screenshots/todayapp/30-home-active-room-badge.jpg', caption: 'todayappActiveRoom' },
      { src: '/assets/screenshots/todayapp/26-chat-2-participants.jpg', caption: 'todayappChatRoom' },
      { src: '/assets/screenshots/todayapp/29-chat-send-message.jpg', caption: 'todayappChatSend' },
      { src: '/assets/screenshots/todayapp/16-signup-verify-link-sent.jpg', caption: 'todayappEmailVerify' },
      { src: '/assets/screenshots/todayapp/24-profile-sheet.jpg', caption: 'todayappProfile' },
    ],
  },
  {
    id: 2,
    title: '특정 객체 자동조준 터렛',
    description: '웹캠 영상에서 YOLOv8과 얼굴 인식으로 특정 인물을 실시간으로 골라내고, 화면 중심과의 오차를 시리얼 통신으로 아두이노에 전달해 서보모터가 대상을 부드럽게 따라가도록 만든 프로젝트입니다. 절대 각도가 아닌 상대 각도로 서보를 제어해 추적이 끊기지 않도록 했고, 조준 상태가 3초 이상 유지되면 자동으로 발사 신호를 보내도록 구현했습니다.',
    descKey: 'turret',
    category: 'embedded',
    tags: ['Python', 'OpenCV', 'PyTorch', 'Arduino', 'C++'],
    github: 'https://github.com/ohdongE/AutoAimingTurret',
    demo: '',
  },
  {
    id: 3,
    title: '손 제스처 제어 시스템',
    description: 'MediaPipe로 손가락 개수를 실시간으로 인식해 블루투스로 아두이노에 신호를 보내고, 인식된 제스처에 따라 LED·모터·부저·LCD를 각각 다르게 반응시키는 시스템입니다. 손이 화면에서 사라져 신호가 1초 이상 끊기면 별도의 정지 명령 없이도 자동으로 초기 상태로 복귀하도록 설계해, 손을 떼는 것만으로 안전하게 멈추도록 했습니다.',
    descKey: 'gesture',
    category: 'embedded',
    tags: ['Python', 'OpenCV', 'MediaPipe', 'Arduino', 'C'],
    github: 'https://github.com/ohdongE/HandGestureController',
    demo: '',
  },
  {
    id: 4,
    title: 'LocalCoderAgent',
    description: 'Qwen2.5-Coder 모델을 한국어 코드 어시스턴트로 직접 LoRA 파인튜닝하고 Ollama로 배포한 로컬 AI 에이전트입니다. FastAPI로 인증과 요청 제한을 갖춘 웹 서버를 구축해 GPU 자원이 함부로 소모되지 않도록 했고, Cloudflare Tunnel로 실제 도메인에 연결해 로컬 환경을 벗어나 어디서든 접속할 수 있는 서비스 형태로 완성했습니다.',
    descKey: 'localcoder',
    category: 'ai',
    tags: ['Python', 'PyTorch', 'FastAPI', 'Ollama', 'Cloudflare'],
    github: 'https://github.com/ohdongE/LocalCoderAgent',
    demo: 'https://chat.oswdev.cloud',
  },
  {
    id: 6,
    title: '워카웃 (WorkOut)',
    description: 'SwiftUI로 만든 iOS 운동 기록 앱입니다. 운동 기록을 근육별 회복 속도로 감쇠시키는 피로도 모델과, 하나의 운동이 주동근·협응근에 주는 자극을 가중치로 분해하는 매핑 엔진을 직접 설계해 "지금 어느 부위가 얼마나 지쳤는지"를 인체 그림으로 보여줍니다. 홈·잠금화면 위젯과 다이나믹 아일랜드로 앱 밖에서도 회복 상태를 확인할 수 있고, 인바디 CSV를 불러와 체성분 변화를 4분면으로 분석하도록 했습니다. 외부 라이브러리 없이 순수 Apple 프레임워크만 사용했으며, SwiftUI와 앱 아키텍처를 직접 익히기 위한 학습용으로 제작한 프로젝트입니다.',
    descKey: 'workout',
    category: 'mobile',
    tags: ['Swift', 'SwiftUI', 'iOS', 'WidgetKit'],
    github: 'https://github.com/ohdongE/WorkOutApplication',
    demo: '',
    screenshots: [
      { src: '/assets/screenshots/workout/01-home.jpg', caption: 'workoutHome' },
      { src: '/assets/screenshots/workout/02-home-plan-select.jpg', caption: 'workoutPlanSelect' },
      { src: '/assets/screenshots/workout/03-report-fatigue-map.jpg', caption: 'workoutFatigueMap' },
      { src: '/assets/screenshots/workout/04-report-volume-radar.jpg', caption: 'workoutVolumeRadar' },
      { src: '/assets/screenshots/workout/05-workout-session.jpg', caption: 'workoutSession' },
      { src: '/assets/screenshots/workout/06-workout-ai-coach.jpg', caption: 'workoutAiCoach' },
      { src: '/assets/screenshots/workout/07-inbody-history.jpg', caption: 'workoutInbodyHistory' },
      { src: '/assets/screenshots/workout/08-inbody-ai-coach.jpg', caption: 'workoutInbodyCoach' },
    ],
  },
  {
    id: 5,
    title: '자기소개 포트폴리오',
    description: '지금 보고 계신 이 사이트입니다. React로 직접 만든 싱글페이지 포트폴리오로, 한국어·영어·일본어 3개 언어를 실시간으로 전환하는 다국어 시스템과 섹션 단위 풀스크린 스크롤을 구현했습니다. 프로젝트·기술·자격증 데이터를 컴포넌트에서 분리해 관리하도록 설계했고, 완성된 사이트는 Cloudflare Pages에 배포해 실제 도메인으로 24시간 운영하고 있습니다.',
    descKey: 'portfolio',
    category: 'web',
    tags: ['React', 'JavaScript', 'CSS', 'i18n', 'Cloudflare'],
    github: 'https://github.com/ohdongE/MyInformationHome',
    demo: 'https://oswdev.cloud',
  },
];
